module.exports = __webpack_public_path__ + "img/f33d5640-c440-496a-922a-25f0ee840f4d.cc1ede36.png";